// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal-mask[data-v-2ed6e129] {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper[data-v-2ed6e129] {
  display: table-cell;
  vertical-align: middle;
}
.modal-container[data-v-2ed6e129] {
  width: 40%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header h3[data-v-2ed6e129] {
  margin-top: 0;
  color: #42b983;
}
.modal-body[data-v-2ed6e129] {
  margin: 20px 0;
}
.modal-default-button[data-v-2ed6e129] {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter[data-v-2ed6e129] {
  opacity: 0;
}
.modal-leave-active[data-v-2ed6e129] {
  opacity: 0;
}
.modal-enter .modal-container[data-v-2ed6e129],
.modal-leave-active .modal-container[data-v-2ed6e129] {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.button_close_modal[data-v-2ed6e129] {
  display: flex;
  justify-content: flex-end;
}
.button_close_modal a[data-v-2ed6e129] {
  text-decoration: none;
}
.button_modal[data-v-2ed6e129] {
  display: flex;
  justify-content: flex-end;
}

`, "",{"version":3,"sources":["webpack://./project/private/Resources/js/modals/ModalQuestions.vue"],"names":[],"mappings":";AAuDA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;EACA,6BAAA;AACA;AAEA;EACA,mBAAA;EACA,sBAAA;AACA;AAEA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yCAAA;EACA,yBAAA;EACA,yCAAA;AACA;AAEA;EACA,aAAA;EACA,cAAA;AACA;AAEA;EACA,cAAA;AACA;AAEA;EACA,YAAA;AACA;;AAEA;;;;;;;EAOA;AAEA;EACA,UAAA;AACA;AAEA;EACA,UAAA;AACA;AAEA;;EAEA,6BAAA;EACA,qBAAA;AACA;AAEA;EACA,aAAA;EACA,yBAAA;AACA;AAEA;EACA,qBAAA;AAEA;AAEA;EACA,aAAA;EACA,yBAAA;AACA","sourcesContent":["<template>\n  <div v-if=\"isOpen === true\">\n    <div class=\"modal-mask\">\n      <div class=\"modal-wrapper\">\n        <div class=\"modal-container\">\n          <div class=\"button_close_modal\">\n            <a @click=\"closeModal()\">X</a>\n          </div>\n          <div>\n            <h2>{{ $t('title_popup') }}</h2>\n            <p v-if=\"link.status == 1\">{{ $t('text_popup_in_progress') }}</p>\n            <p v-if=\"link.status == 0\">{{ $t('text_popup_create') }}</p>\n          </div>\n          <div class=\"button_modal\">\n            <a :href=\"link.action\" class=\"btn\">{{ $t('_78') }}</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: \"ModalQuestions\",\n\n  props: {\n    link: {\n      type: Object,\n      required: true,\n    },\n  },\n\n  data() {\n    return {\n      isOpen: false,\n    }\n  },\n\n  mounted() {\n    if(!window.location.pathname.includes(this.link.action)) {\n      this.isOpen = true;\n    }\n\n  },\n\n  methods: {\n    closeModal: function () {\n      this.isOpen = false;\n    }\n  },\n}\n</script>\n\n<style scoped>\n.modal-mask {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: table;\n  transition: opacity 0.3s ease;\n}\n\n.modal-wrapper {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.modal-container {\n  width: 40%;\n  margin: 0px auto;\n  padding: 20px 30px;\n  background-color: #fff;\n  border-radius: 2px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  transition: all 0.3s ease;\n  font-family: Helvetica, Arial, sans-serif;\n}\n\n.modal-header h3 {\n  margin-top: 0;\n  color: #42b983;\n}\n\n.modal-body {\n  margin: 20px 0;\n}\n\n.modal-default-button {\n  float: right;\n}\n\n/*\n * The following styles are auto-applied to elements with\n * transition=\"modal\" when their visibility is toggled\n * by Vue.js.\n *\n * You can easily play with the modal transition by editing\n * these styles.\n */\n\n.modal-enter {\n  opacity: 0;\n}\n\n.modal-leave-active {\n  opacity: 0;\n}\n\n.modal-enter .modal-container,\n.modal-leave-active .modal-container {\n  -webkit-transform: scale(1.1);\n  transform: scale(1.1);\n}\n\n.button_close_modal {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.button_close_modal a {\n  text-decoration: none;\n\n}\n\n.button_modal {\n  display: flex;\n  justify-content: flex-end;\n}\n\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
